const $ = require('jquery')
const Promise = require('bluebird')

const Metronic = require('./stylers/metronic')
const QuickSideBar = require('./stylers/quick_sidebar')
const Layout = require('./stylers/layout')
const Demo = require('./stylers/demo')
const Sci = require('./stylers/sci')
const history = window.history

/**
 * Helper responsavel pela estilização de elementos de
 * forma que tudo fique unificado em um só lugar, ao invés de separados
 */
const styler = (self = $(document)) => new Promise((resolve, reject) => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual'
    }

    Metronic.init()
    Layout.init()
    Demo.init()
    QuickSideBar()
    Sci(self)
    resolve()
})

module.exports = styler



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/styler.js